
module.exports = {
  // Payslip PDF labels
  "No IC": "ஐசி எண்",
  "Employee No": "பணியாளர் எண்",
  "Sr. No": "வரிசை எண்",
  "Earnings": "வருமானம்",
  "Total Earning": "மொத்த வருமானம்",
  "Deductions": "பிடித்தங்கள்",
  "Tax Amount": "வரித் தொகை",
  "Employee Deduction": "பணியாளர் பிடித்தம்",
  "Tax No": "வரி எண்",
  "EPF No": "ஈபிஎஃப் எண்",
  "SOCSO No": "சொக்சோ எண்",
  "Bank Name": "வங்கியின் பெயர்",
  "Account No": "கணக்கு எண்",
  "Employer Deduction": "முதலாளி பிடித்தம்",
  "Net Salary": "நிகர சம்பளம்",
  "Page": "பக்கம்",
  "of": "/",
  "Issue Date": "வழங்கிய தேதி",
  "Pay Add On": "கூடுதல் ஊதியம்",
  "Unpaid days": "சம்பளமில்லா நாட்கள்",
  "Dependant Active Spouse": "சார்ந்த துணைவர்",
  "Dependant Active Children": "சார்ந்த குழந்தைகள்",
  "Advanced Salary Deduction": "முன்பணச் சம்பளப் பிடித்தம்",
  "Payble": "செலுத்த வேண்டியது",
  "Net Pay to Bank Account": "வங்கிக் கணக்கிற்கு நிகர ஊதியம்",
  "Actual Rate": "உண்மையான விகிதம்",
  "Others": "மற்றவை",
  "Come Late & Leave Early": "தாமத வருகை & முன்கூட்டிய வெளியேற்றம்",
  "Unpaid Leave": "சம்பளமில்லா விடுப்பு",
  "Payroll Period": "ஊதியக் காலம்",
  "Employee Code": "பணியாளர் குறியீடு",
  "Joining Date": "சேர்ந்த தேதி",
  "Foreign Name": "வெளிநாட்டுப் பெயர்",
  "Employee Name": "பணியாளர் பெயர்",
  "Basic Rate": "அடிப்படை விகிதம்",
  "Units": "அலகுகள்",
  "Total Earnings": "மொத்த வருமானம்",
  "Total Deductions": "மொத்த பிடித்தங்கள்",
  "Net Pay": "நிகர ஊதியம்",
  "Dept": "துறை",
  "Pay Period": "ஊதியக் காலம்",
  "Income Tax": "வருமான வரி",
  "Annual Leave Taken": "எடுத்த ஆண்டு விடுப்பு",
  "Sick Leave Taken": "எடுத்த மருத்துவ விடுப்பு",
  "EPF No.": "ஈபிஎஃப் எண்",
  "Tax No.": "வரி எண்",
  "SOCSO No.": "சொக்சோ எண்",
  "Bank No.": "வங்கி எண்",
  "Current Month": "நடப்பு மாதம்",
  "Emp'ee": "பணியாளர்",
  "Emp'er": "முதலாளி",
  "Year-To-Date": "ஆண்டு தொடக்கம் முதல்",
  "Non Income Loan": "வருமானமற்ற கடன்",
  "Salary Adjustment": "சம்பளச் சரிசெய்தல்",
  "Basic Salary": "அடிப்படைச் சம்பளம்",
  "Provident Fund": "வருங்கால வைப்பு நிதி",
  "Professional Tax": "தொழில் வரி",
  "Employer": "முதலாளி",
  "Gratuity Provision": "பணிக்கொடை ஒதுக்கீடு",
  "Salary Slip": "சம்பளச் சீட்டு",
  "Working Days": "வேலை நாட்கள்",
  "Date of Join": "சேர்ந்த தேதி",
  "PAN No.": "பான் எண்",
  "PF UAN No.": "பிஎஃப் யுஏஎன் எண்",
  "ESI No.": "இஎஸ்ஐ எண்",
  "Bank A/C No.": "வங்கிக் கணக்கு எண்",
  "Earnings & Deductions": "வருமானம் & பிடித்தங்கள்",
  "Gross Earnings": "மொத்த வருமானம்",
  "Net Pay (Take Home)": "நிகர ஊதியம் (கையில்)",
  "Leave Balance": "விடுப்பு இருப்பு",
  "Annual Taken": "ஆண்டு விடுப்பு எடுத்தது",
  "Sick Taken": "மருத்துவ விடுப்பு எடுத்தது",
  "Payment Details": "கட்டண விவரங்கள்",
  "PF UAN": "பிஎஃப் யுஏஎன்",
  "Bank A/C": "வங்கிக் கணக்கு",
  "Statutory Summary": "சட்டப்பூர்வ சுருக்கம்",
  "Employer contributions (PF, ESI, Gratuity) are informational and not deducted from salary.": "முதலாளி பங்களிப்புகள் (PF, ESI, பணிக்கொடை) தகவலுக்கு மட்டுமே; சம்பளத்திலிருந்து பிடிக்கப்படுவதில்லை.",
  "Computer Generated - No Signature Required": "கணினியால் உருவாக்கப்பட்டது - கையொப்பம் தேவையில்லை",
  "Payslip figures are not available for this employee.": "இந்தப் பணியாளருக்குச் சம்பளச் சீட்டு விவரங்கள் கிடைக்கவில்லை.",
  "Employee Details": "பணியாளர் விவரங்கள்",
  "ABA Account": "ஏபிஏ கணக்கு",
  "Salary Tax Calculation": "சம்பள வரி கணக்கீடு",
  "Gross Taxable Pay": "மொத்த வரிக்குட்பட்ட ஊதியம்",
  "Dependants": "சார்ந்தோர்",
  "Dependant Deduction": "சார்ந்தோர் பிடித்தம்",
  "Taxable Salary": "வரிக்குட்பட்ட சம்பளம்",
  "Tax Rate": "வரி விகிதம்",
  "non-resident": "குடியுரிமையற்றவர்",
  "Salary Tax": "சம்பள வரி",
  "Other Items": "பிற விவரங்கள்",
  "Pension Scheme": "ஓய்வூதியத் திட்டம்",
  "Advance Salary Deduction": "முன்பணச் சம்பளப் பிடித்தம்",
  "Loan Repayment": "கடன் திருப்பிச் செலுத்துதல்",
  "Unpaid Days": "சம்பளமில்லா நாட்கள்",
  "Prepared By": "தயாரித்தவர்",
  "Approved By": "அங்கீகரித்தவர்",
  "Received By (Employee)": "பெற்றவர் (பணியாளர்)",
  "This is a computer generated payslip. KHR amounts are converted at the payroll exchange rate.": "இது கணினியால் உருவாக்கப்பட்ட சம்பளச் சீட்டு. KHR தொகைகள் ஊதிய மாற்று விகிதத்தில் மாற்றப்பட்டுள்ளன.",
  "January": "ஜனவரி",
  "February": "பிப்ரவரி",
  "March": "மார்ச்",
  "April": "ஏப்ரல்",
  "May": "மே",
  "June": "ஜூன்",
  "July": "ஜூலை",
  "August": "ஆகஸ்ட்",
  "September": "செப்டம்பர்",
  "October": "அக்டோபர்",
  "November": "நவம்பர்",
  "December": "டிசம்பர்",
  "Payslip for": "சம்பளச் சீட்டு",
  "ABA Number Account": "ஏபிஏ கணக்கு எண்",
  "Month Basic Pay": "மாத அடிப்படை ஊதியம்",
  "Gross Pay": "மொத்த ஊதியம்",
  "Dependent Spouse": "சார்ந்த துணைவர்",
  "Dependent Children": "சார்ந்த குழந்தைகள்",
  "Dependent Deduction": "சார்ந்தோர் பிடித்தம்",
  "Pension Scheme 2%": "ஓய்வூதியத் திட்டம் 2%",
  "No.": "எண்ணிக்கை",
  "Salary Tax (ToS)": "சம்பள வரி (ToS)",

  "Yes": "ஆம்",
  "Male": "ஆண்",
  "Female": "பெண்",
  "Other": "மற்றவை",
  "Non": "Non",
  "Spouse": "துணைவர்/துணைவி",
  "Child": "குழந்தை",
  "husband": "கணவர்",
  "brother": "சகோதரர்",
  "sister": "சகோதரி",
  "grandfather": "grandfather",
  "grandmother": "grandmother",
  "grandson": "grandson",
  "granddaughter": "granddaughter",
  "uncle": "uncle",
  "aunt": "aunt",
  "nephew": "nephew",
  "niece": "niece",
  "cousin": "cousin",
  "friend": "நண்பர்",
  "Monthly": "மாதாந்திர",
  "Yearly": "வருடாந்திர",
  "Security": "பாதுகாப்பு",
  "and": "மற்றும்",
  "Sub": "Sub",
  "Admin": "நிர்வாகி",
  "Comment": "கருத்து",
  "Description": "விளக்கம்",
  "See": "பார்க்க",
  "Make": "உருவாக்கு",
  "ON": "ON",
  "Amount": "தொகை",
  "Added": "சேர்க்கப்பட்டது",
  "Successfully": "வெற்றிகரமாக",
  "Updated": "புதுப்பிக்கப்பட்டது",
  "Your": "உங்கள்",
  "Form": "படிவம்",
  "form": "form",
  "is": "is",
  "submitted": "submitted",
  "Manage": "நிர்வகி",
  "marked": "marked",
  "with": "with",
  "are": "are",
  "required": "தேவை",
  // "Monthly":"ប្រចាំខែ",
  "Hourly": "மணிநேர",
  "Weekly": "வாராந்திர",
  "OK": "சரி",
  "Complaint": "புகார்",
  "From": "இருந்து",
  "Subject": "பொருள்",
  "Category": "வகை",
  "Number of Days Outstanding": "Number of Days Outstanding",
  "Open": "திற",
  "Are you sure?": "நிச்சயமாகவா?",
  "that you want to delete this record?": "இந்த பதிவை நீக்க விரும்புகிறீர்களா?",
  "Deleted": "நீக்கப்பட்டது",

  "View": "பார்க்க",
  "Against": "Against",
  "Uploaded": "பதிவேற்றப்பட்டது",
  "Taken": "Taken",
  "Attendance": "வருகைப்பதிவு",
  "In-Time": "உள் நேரம்",
  "Out-Time": "வெளியேறும் நேரம்",
  "Total": "மொத்தம்",
  "Work": "வேலை",
  "Time": "நேரம்",
  "Break": "இடைவேளை",
  "Are you sure that you want to edit this record which done by hr admin?": "HR ADMIN செய்த இந்த பதிவைத் திருத்த விரும்புகிறீர்களா?",
  "Are you sure that you want to edit this record which done by employee login?": "பணியாளர் உள்நுழைவில் செய்யப்பட்ட இந்த பதிவைத் திருத்த விரும்புகிறீர்களா?",
  "Deleted Successfully": "Deleted Successfully",
  "Archived": "காப்பகப்படுத்தப்பட்டது",
  "Check In Radius Check": "Check In Radius Check",
  "Check Out Radius Check": "Check Out Radius Check",
  "Done By HR ADMIN": "Done By HR ADMIN",
  "Write reason of delete:": "Write reason of delete:",
  //"Are you sure?":"តើអ្នកប្រាកដទេ?",
  "Are you sure that you want to delete this record?": "Are you sure that you want to delete this record?",
  "ADD": "சேர்",
  "Hrs": "மணி",
  "Min": "நிமிடம்",
  "Enter Rest Time as Hrs:Min": "Enter Rest Time as Hrs:Min",
  "Enter Early Leaving as Hrs:Min": "Enter Early Leaving as Hrs:Min",
  "Please enter In time": "உள் நேரத்தை உள்ளிடவும்",
  "Please enter Out time": "வெளியேறும் நேரத்தை உள்ளிடவும்",
  "Can not Add Attendance": "வருகைப்பதிவைச் சேர்க்க முடியாது",
  "YYYY-MM-DD": "YYYY-MM-DD",
  "All fields marked with * are required": "* குறியிடப்பட்ட அனைத்து புலங்களும் அவசியம்",
  "Positions": "Positions",
  "Departments": "Departments",
  "Actual": "Actual",
  "Reason": "Reason",
  "Can not Add Privilege": "Can not Add Privilege",
  "Can not Edit Privilege": "Can not Edit Privilege",
  "Can not Delete Privilege": "Can not Delete Privilege",
  "Pending": "நிலுவையில்",
  "Approved": "அங்கீகரிக்கப்பட்டது",
  "Rejected": "நிராகரிக்கப்பட்டது",
  "Please": "தயவுசெய்து",
  //"Add":"បន្ថែម",
  "Check Your Leave Bank": "Check Your Leave Bank",
  "From Date should not be greater than To Date": "தொடக்க தேதி முடிவு தேதியை விட அதிகமாக இருக்கக்கூடாது",
  //"Check Your Leave Bank":"ពិនិត្យសមតុល្យវត្តមានរបស់អ្នក",
  "Please add leave templete for this employee ": "Please add leave templete for this employee ",
  "Leave present at this date": "Leave present at this date",
  "can": "can",
  "not": "not",
  "Start": "தொடக்கம்",
  "End": "முடிவு",
  "Duration": "கால அளவு",
  "Starts in first half": "Starts in first half",
  "Starts in second half": "Starts in second half",
  "Full Day Leave": "Full Day Leave",
  "Post Edit Remark": "Post Edit Remark",
  "Attachment": "இணைப்பு",
  "Staff": "ஊழியர்",
  "Staffs": "Staffs",
  "Exists": "Exists",
  "Not": "Not",
  "Found": "Found",
  "Any": "Any",
  "App": "App",
  "URL": "URL",
  "Go to App Url": "Go to App Url",
  "Created At": "Created At",
  "Announcement": "Announcement",
  "Announcements": "Announcements",
  "Success": "Success",
  "Available": "Available",
  "Model": "Model",
  "Asset": "Asset",
  "Assigned": "Assigned",
  "Issue On": "Issue On",
  "Sr": "Sr",
  "Please Start the camera": "Please Start the camera",
  "Please add the image": "Please add the image",
  "Your last Checked out": "Your last Checked out",

  "Bulk Import Failed": "Bulk Import Failed",
  "in": "in",
  "Sample": "Sample",
  "CSV": "CSV",
  "File": "File",
  "Upload": "Upload",
  "You must set location allow": "You must set location allow",
  "Check Inout": "Check Inout",
  "Submit": "Submit",
  "Retry": "Retry",
  "You already Checked In": "You already Checked In",
  "Check In": "Check In",
  "Check Out": "Check Out",
  "Latitude": "Latitude",
  "Longitude": "Longitude",
  "List": "List",
  "Employees": "பணியாளர்கள்",
  "Dashboard": "டாஷ்போர்டு",
  "Select": "தேர்ந்தெடு",
  "Organization": "நிறுவனம்",
  "Status": "நிலை",
  "Department": "துறை",
  "Position": "பதவி",
  "Export": "ஏற்றுமதி",
  "Import": "இறக்குமதி",
  "Update": "புதுப்பி",
  "Qrcode": "Qrcode",
  "Search": "தேடு",
  "No": "இல்லை",
  "New": "புதிய",
  "Complaints": "Complaints",
  "Information": "தகவல்",
  "Employee": "பணியாளர்",
  "Email": "மின்னஞ்சல்",
  "Mobile": "மொபைல்",
  "Action": "செயல்",
  "Add": "சேர்",
  "Edit": "திருத்து",
  "Basic": "அடிப்படை",
  "Info": "தகவல்",
  "Leaves": "விடுப்புகள்",
  "Points": "புள்ளிகள்",
  "Documents": "ஆவணங்கள்",
  "Assets": "சொத்துகள்",
  "Salary": "சம்பளம்",
  "Note": "குறிப்பு",
  "Payslips": "Payslips",
  "Emergency": "அவசரம்",
  "Contacts": "தொடர்புகள்",
  "First": "First",
  "Name": "பெயர்",
  "ID": "அடையாள எண்",
  "Last": "Last",
  "Middle": "Middle",
  "Address": "முகவரி",
  "Gender": "பாலினம்",
  "Date": "தேதி",
  "Of": "Of",
  "Birth": "பிறப்பு",
  "Timezone": "நேர மண்டலம்",
  "Location": "இருப்பிடம்",
  "Long": "Long",
  "Lat": "Lat",
  "Restrict": "Restrict",
  "CheckIn": "CheckIn",
  "Radius": "Radius",
  "CheckOut": "CheckOut",
  "Nationality": "தேசியம்",
  "Resident": "குடியிருப்பாளர்",
  "Shift": "ஷிப்ட்",
  "Group": "குழு",
  "JD": "JD",
  "Title": "தலைப்பு",
  "Access": "அணுகல்",
  "UserType": "UserType",
  "QR": "QR",
  "Download": "பதிவிறக்கு",
  "Cancel": "ரத்துசெய்",
  "Enter": "உள்ளிடு",
  "Password": "கடவுச்சொல்",
  "In-Active": "செயலற்றது",
  "Dependent": "Dependent",
  "Relation": "உறவு",
  "Present": "Present",
  "Age": "வயது",
  "Save": "சேமி",
  "changes": "changes",
  "Leave": "விடுப்பு",
  "Template": "டெம்ப்ளேட்",
  "Current": "தற்போதைய",
  "Balance": "இருப்பு",
  "Allowed": "அனுமதிக்கப்பட்ட",
  "Negative": "எதிர்மறை",
  "Transaction": "பரிவர்த்தனை",
  "History": "வரலாறு",
  "Manual": "Manual",
  "Credit": "வரவு",
  "Debit": "பற்று",
  "Close": "மூடு",
  "Frequency": "அதிர்வெண்",
  "Quantity": "அளவு",
  "Paycode": "Paycode",
  "Type": "வகை",
  "Opening": "Opening",
  "All": "அனைத்தும்",
  "Document": "ஆவணம்",
  "Days": "நாட்கள்",
  "to": "முதல்",
  "Already": "ஏற்கனவே",
  "Expired": "காலாவதியானது",
  "Expiry": "காலாவதி",
  "Remark": "குறிப்பு",
  "Declaration": "அறிவிப்பு",
  "Issue": "சிக்கல்",
  "Return": "திரும்பு",
  "Allowance": "படிகை",
  "Code": "குறியீடு",
  "Taxable": "வரி விதிக்கத்தக்க",
  "tax": "வரி",
  "Telephone": "தொலைபேசி",
  "Distance": "தூரம்",
  "Check out details are Not Available": "Check out details are Not Available",
  "Details": "விவரங்கள்",
  "Get": "பெறு",
  "Image": "படம்",
  "This entry is generated by Admin": "This entry is generated by Admin",
  "for": "for",
  "CheckInOut": "CheckInOut",
  "enter": "enter",
  "Email ID": "Email ID",
  "password": "password",
  "Incorrect": "Incorrect",
  "Credentials": "Credentials",
  "Login": "உள்நுழைவு",
  "Unsuccessful": "Unsuccessful",
  "Forgot": "மறந்துவிட்டீர்களா",
  "Sign Up Now": "இப்போது பதிவு செய்க",
  "Sign in": "உள்நுழைக",
  "Banner": "Banner",
  "Size": "அளவு",
  "Sequence": "வரிசை",
  "Publish": "வெளியிடு",
  "Blog": "வலைப்பதிவு",
  "Blogs": "வலைப்பதிவுகள்",
  "Draft": "வரைவு",
  "Unpublished": "வெளியிடப்படாதது",
  "Published": "வெளியிடப்பட்டது",
  "type": "type",
  "Video": "வீடியோ",
  "Back to": "Back to",
  "Chapters": "அத்தியாயங்கள்",
  // "Chapters":"ជំពូក",
  "Chapter": "அத்தியாயம்",
  "Topics": "தலைப்புகள்",
  "Under this": "Under this",
  "Course": "பாடநெறி",
  "PDF": "PDF",
  "VIDEO": "VIDEO",
  "Topic": "தலைப்பு",
  "Involved": "Involved",
  "By": "By",
  "Welcome back": "மீண்டும் வரவேற்கிறோம்",
  "Data": "தரவு",
  "For": "For",
  "From Date": "தொடக்க தேதி",
  "To Date": "முடிவு தேதி",
  "TODAY'S": "TODAY'S",
  "ATTENDANCE": "ATTENDANCE",
  "THIS": "THIS",
  "MONTH": "MONTH",
  "LEAVE": "LEAVE",
  "TOTAL": "TOTAL",
  "ORGANIZATIONS": "ORGANIZATIONS",
  "ACTIVE": "ACTIVE",
  "EMPLOYEES": "EMPLOYEES",
  "Today's": "Today's",
  "Project Head": "திட்டத் தலைவர்",
  "Contact No": "தொடர்பு எண்",
  "Add More": "மேலும் சேர்",
  "Guest": "விருந்தினர்",
  "Visit To": "Visit To",
  "License Plate": "License Plate",
  "Add Checkout Time": "Add Checkout Time",
  "Business Visit": "Business Visit",
  "Meeting": "கூட்டம்",
  "Personal Visit": "Personal Visit",
  "Interview": "நேர்காணல்",
  "Presentation": "விளக்கக்காட்சி",
  "Sales Visit": "Sales Visit",
  "Client Visit": "Client Visit",
  "Supplier Visit": "Supplier Visit",
  //"Other":"ផ្សេងៗ",
  "Take": "Take",
  "HR": "மனிதவள",
  "Email Already Exists": "மின்னஞ்சல் ஏற்கனவே உள்ளது",
  "HR Code Already Exists": "HR குறியீடு ஏற்கனவே உள்ளது",
  "Account Name Already Exists": "கணக்கு பெயர் ஏற்கனவே உள்ளது",
  "Account Name should not be greater than 10 characters": "Account Name should not be greater than 10 characters",
  "Database not found with given account name, Please create database first": "கொடுக்கப்பட்ட கணக்கு பெயருக்கான தரவுத்தளம் கிடைக்கவில்லை. முதலில் தரவுத்தளத்தை உருவாக்கவும்",
  "Database not available to create HR admin": "HR நிர்வாகியை உருவாக்க தரவுத்தளம் கிடைக்கவில்லை",
  "Min.Amount": "Min.Amount",
  "Max.Amount": "Max.Amount",
  "Base amount": "Base amount",
  "Percentage": "சதவீதம்",
  "Tax": "வரி",
  "Dependence Allowance": "Dependence Allowance",
  "Tax Bracket List": "Tax Bracket List",
  "Tax Bracket": "Tax Bracket",
  "Super User": "சூப்பர் பயனர்",
  "Day": "நாள்",
  "Monday": "திங்கட்கிழமை",
  "Rest-Time": "Rest-Time",
  "tuesday": "செவ்வாய்க்கிழமை",
  "Wednesday": "புதன்கிழமை",
  "Thursday": "வியாழக்கிழமை",
  "Friday": "வெள்ளிக்கிழமை",
  "Saturday": "சனிக்கிழமை",
  "Sunday": "ஞாயிற்றுக்கிழமை",
  "Signup": "பதிவு",
  "Requests": "கோரிக்கைகள்",
  "Reference": "குறிப்பு",
  "Account": "கணக்கு",
  "Personal": "தனிப்பட்ட",
  "Create": "உருவாக்கு",
  "user Roles": "user Roles",
  "Task": "பணி",
  "In Progress": "நடைபெறுகிறது",
  "Completed": "முடிந்தது",
  "Logs Present in this Task so cant be deleted": "Logs Present in this Task so cant be deleted",
  "Log Text": "Log Text",
  "Logs": "Logs",
  "Projects": "திட்டங்கள்",
  "Member": "உறுப்பினர்",
  "Moderate": "Moderate",
  "Low": "குறைவு",
  "High": "உயர்",
  "Very High": "மிக உயர்ந்த",
  "Priority": "முன்னுரிமை",
  "Visit": "Visit",
  "Weight": "எடை",
  "Value": "மதிப்பு",
  "Score": "மதிப்பெண்",
  "Completion": "நிறைவு",
  "Uploaded image has not valid Height and Width": "பதிவேற்றிய படத்தின் உயரமும் அகலமும் சரியாக இல்லை",
  "Promotion": "பதவி உயர்வு",
  "Redirect": "Redirect",
  "Task Presnt in this Project so cant be deleted": "Task Presnt in this Project so cant be deleted",
  "Now": "இப்போது",
  "Importance": "முக்கியத்துவம்",
  "Performance Kpi": "Performance Kpi",
  "Please add the reason of delete": "நீக்குவதற்கான காரணத்தைச் சேர்க்கவும்",
  "Role": "பாத்திரம்",
  "Please select at least one module": "குறைந்தது ஒரு தொகுதியையாவது தேர்ந்தெடுக்கவும்",
  "Analyst": "Analyst",
  "analytics": "analytics",
  "Top Selling": "Top Selling",
  "Shop": "Shop",
  "Cart": "Cart",
  "File size less than 1 MB": "கோப்பு அளவு 1 MB-க்கு குறைவாக இருக்க வேண்டும்",
  "Check Discount Price": "Check Discount Price",
  "Required": "தேவை",
  "Investigating": "Investigating",
  "Incident": "சம்பவம்",
  "Job": "வேலை",
  "Level": "நிலை",
  "Grade": "தரம்",
  "Attach": "Attach",
  "Functions": "Functions",
  "Qualification": "தகுதி",
  "Responsibilities": "பொறுப்புகள்",
  "Reporting": "Reporting",
  "Perks": "Perks",
  "Benefits": "நன்மைகள்",
  "Make-Model": "Make-Model",
  "Check IN/OUT": "Check IN/OUT",
  "Please Upload the File": "Please Upload the File",
  "No mid month": "No mid month",
  "Mid Month": "Mid Month",
  "Payroll": "ஊதியம்",
  "Process": "செயல்முறை",
  "Bonus": "போனஸ்",
  "Working": "பணியில்",
  "Test": "சோதனை",
  "Live": "Live",
  "Line": "Line",
  "Entry": "Entry",
  "Currency": "நாணயம்",
  "Rate": "விகிதம்",

  "Banners": "Banners",
  "Orders": "ஆர்டர்கள்",
  "Product": "தயாரிப்பு",
  "Pay Codes": "Pay Codes",
  "Comments": "கருத்துகள்",
  "Career": "தொழில்",
  "Profile": "சுயவிவரம்",
  "Employee Presence": "Employee Presence",
  "Employee Absence": "Employee Absence",
  "My Job Description": "My Job Description",
  "Job Description": "Job Description",
  "Settings": "அமைப்புகள்",
  "Public Holidays": "பொது விடுமுறைகள்",
  "Master Department": "Master Department",
  "Point Declaration": "Point Declaration",
  "User Role": "User Role",
  "Admin Apps": "Admin Apps",
  "Groups": "குழுக்கள்",
  "Employee Bulk Import": "Employee Bulk Import",
  "Guests": "Guests",
  "Check In Out": "Check In Out",
  "Incident Report": "Incident Report",
  "Tasks": "Tasks",
  "Work Plan": "Work Plan",
  "My": "My",
  "Promotions": "Promotions",
  "Payroll Line Entry": "Payroll Line Entry",
  "Employee Chat": "Employee Chat",
  "Messages": "செய்திகள்",
  "Training": "பயிற்சி",
  "SignUp Requests": "SignUp Requests",
  "My Profile": "என் சுயவிவரம்",
  "Employee Career": "Employee Career",
  "Job Post": "வேலை இடுகை",
  "Application List": "விண்ணப்ப பட்டியல்",
  "Job Frontend Url": "Job Frontend Url",
  "Manage Shifts": "ஷிப்ட்களை நிர்வகி",
  "Shift Scheduler": "ஷிப்ட் அட்டவணையாளர்",
  "Shift Scheduler History": "Shift Scheduler History",
  "Shift Schedule": "Shift Schedule",
  "Constants": "Constants",
  "No Preference": "No Preference",
  "Fresher": "Fresher",
  "Year": "ஆண்டு",
  "Short Description": "சுருக்கமான விளக்கம்",
  "Long Description": "விரிவான விளக்கம்",
  "Add Thumbnail Image": "Add Thumbnail Image",
  "Enter Valid link": "Enter Valid link",
  "In Stock": "கையிருப்பில் உள்ளது",
  "Out Of Stock": "கையிருப்பில் இல்லை",
  "In Active": "In Active",
  "Ordered": "ஆர்டர் செய்யப்பட்டது",
  "Accepted": "ஏற்றுக்கொள்ளப்பட்டது",
  "Rejected and Closed": "நிராகரிக்கப்பட்டு மூடப்பட்டது",
  "Shipped/InTransit": "Shipped/InTransit",
  "Completed and Closed": "முடிந்து மூடப்பட்டது",
  "Cancelled and Closed": "ரத்துசெய்யப்பட்டு மூடப்பட்டது",
  "Order No": "ஆர்டர் எண்",
  "Order On": "Order On",
  "Product Feature": "Product Feature",
  "Subtotal": "கூட்டுத்தொகை",
  "No items in the cart": "No items in the cart",
  "Place Order": "ஆர்டர் செய்",
  "Change": "Change",
  // "Select":"ជ្រើសរើស",
  "Language": "மொழி",

  ////////////////////
  "Job Title": "வேலை தலைப்பு",
  "All Employee": "All Employee",
  "Day Leave": "Day Leave",
  "System Logs": "சிஸ்டம் பதிவுகள்",
  "Employee Documents": "பணியாளர் ஆவணங்கள்",
  "Leave Types": "விடுப்பு வகைகள்",
  "Allowance Type": "படிகை வகை",
  "Allowance Code": "Allowance Code",
  "Note Code": "Note Code",
  "Document Code": "Document Code",
  "Comment Category": "Comment Category",
  "Comment Type": "Comment Type",


  "My Shift Schedule": "My Shift Schedule",
  "My Orders": "My Orders",
  "Organization Blogs": "Organization Blogs",
  "My Attendance": "My Attendance",
  "My Leaves": "My Leaves",
  "Access Code": "Access Code",
  "My Points": "My Points",
  "My Documents": "My Documents",
  "My Assests": "My Assests",
  "My Payslips": "My Payslips",
  "Sub Admin": "Sub Admin",
  "Manage Tax Brackets": "Manage Tax Brackets",
  "All Shifts": "All Shifts",
  "Shift Scheduler Import": "Shift Scheduler Import",
  "Project Task": "Project Task",
  "Employee Training": "Employee Training",
  "Employee Shop": "Employee Shop",
  "Product Category": "தயாரிப்பு வகை",
  "Products": "தயாரிப்புகள்",
  "Public Holiday": "பொது விடுமுறை",
  "Blog Type": "Blog Type",
  "Job Type": "வேலை வகை",
  "Course Type": "பாடநெறி வகை",
  "Annoucement Type": "Annoucement Type",


  "Add/Subtract": "Add/Subtract",
  "Mood": "மனநிலை",
  "Negative Balance": "Negative Balance",
  "Leave Bank Report": "Leave Bank Report",
  "Payroll Type": "Payroll Type",
  "Flat Salary": "Flat Salary",
  "Salary Attendance": "Salary Attendance",
  "Salary Attendance + OT": "Salary Attendance + OT",
  "Hourly Wages": "Hourly Wages",
  "Deduction": "கழித்தல்",
  "Adjustment": "சரிசெய்தல்",
  "Settlements": "Settlements",
  "Current Balance": "தற்போதைய இருப்பு",
  "Allowed Negative Balance": "Allowed Negative Balance",
  "No Record Found": "பதிவு எதுவும் கிடைக்கவில்லை",
  //"Work Schedular":"Work Schedular",



  ////////Date 23/2/2kl
  "Upcoming": "வரவிருக்கும்",
  //"Today's":"Today's",
  "Absent": "வராதவர்",
  "Apply": "பயன்படுத்து",
  "Database Host": "Database Host",
  "Database User": "Database User",
  "Database Password": "Database Password",
  "Primary Database Name": "Primary Database Name",
  "Payroll Database Name": "Payroll Database Name",
  "Language Translation Type": "Language Translation Type",
  "Google Transaltor": "Google Transaltor",
  "Custom": "தனிப்பயன்",
  "Default Language": "இயல்புநிலை மொழி",
  "English": "ஆங்கிலம்",
  "Khemer": "Khemer",
  "Chinese": "சீனம்",
  "More than 1 organization cannot be added": "1-க்கும் மேற்பட்ட நிறுவனத்தைச் சேர்க்க முடியாது",
  "Organization Code already exists": "நிறுவனக் குறியீடு ஏற்கனவே உள்ளது",
  "Add Payslip Header or Footer or organization logo": "Add Payslip Header or Footer or organization logo",
  "Company Policy": "நிறுவனக் கொள்கை",
  "Employee Handbook": "பணியாளர் கையேடு",
  "Payslip Header": "Payslip Header",
  "Payslip Footer": "Payslip Footer",
  "Color Code": "Color Code",
  // "Sequence":"Sequence",

  /****29 march */

  'Shifts': "Shifts",
  "Visitor": "Visitor",
  "Work Scheduler": "Work Scheduler",
  "Work Scheduler History": "Work Scheduler History",
  "Work Scheduler Import": "Work Scheduler Import",
  "Vehicle": "வாகனம்",
  "Total IN Visitor": "Total IN Visitor",



  /////////Date 28/4/23/////////
  "Seniority Pay": "பணிமூப்பு ஊதியம்",
  "Convert to USD Dollar": "Convert to USD Dollar",
  //"":"",
  //'Absent':'Absent',

  "Expire With In Days": "Expire With In Days",
  //"My Profile": "我的简历",
  "Sign out": "வெளியேறு",
  "Outstanding": "Outstanding",
  "Leave Bank": "விடுப்பு வங்கி",

  "Settlement Import": "Settlement Import",
  "Tax Code": "வரி குறியீடு",
  "Business Promotions": "Business Promotions",
  "HR Blog": "HR Blog",
  "Job Discloursere": "Job Discloursere",

  "Payroll Headers": "Payroll Headers",
  "Settlement Type": "Settlement Type",
  "Settlement Code": "Settlement Code",
  "Document Types": "ஆவண வகைகள்",
  "Employee Groups": "பணியாளர் குழுக்கள்",

  "Job ID": "Job ID",
  "Payroll Privilege": "Payroll Privilege",
  "To": "To",
  // "Outstanding": "杰出的",
  // "Mood": "情绪",
  "options": "விருப்பங்கள்",
  "General": "பொது",
  "Very Sad": "Very Sad",

  "Sad": "சோகம்",
  "Just OK": "Just OK",
  "Good": "நன்று",
  "Fantastic": "அற்புதம்",
  "zone": "zone",
  "Rest": "ஓய்வு",

  "NOTE:In Time and Out Time in 24 Hrs Format": "குறிப்பு: உள் நேரம் மற்றும் வெளியேறும் நேரம் 24 மணி வடிவில் இருக்க வேண்டும்",
  //"Please select a date":"Please select a date",
  //"Rest":"Rest",
  "Early Out": "முன்கூட்டியே வெளியேறு",
  "Over Time": "ஓவர்டைம்",
  "Late In": "தாமதமாக வருகை",
  "Previous": "முந்தைய",

  "Records": "பதிவுகள்",
  "Check IN Out Records": "Check IN Out Records",
  "Check IN": "செக்-இன்",
  "Check": "Check",
  // "Title":"Title",
  //"Address":"Address",
  "Owner": "உரிமையாளர்",

  "Address Line": "Address Line",
  "City": "நகரம்",
  "State/Province": "மாநிலம்/மாகாணம்",
  "Country": "நாடு",
  "Attendance Radius (in Meters)": "Attendance Radius (in Meters)",
  // "Company Policy": "Company Policy",
  // "Employee Handbook": "Employee Handbook",
  // "Payslip Header": "Payslip Header",
  // "Payslip Footer": "Payslip Footer",
  "Height": "உயரம்",
  "Width": "அகலம்",

  "ID Template": "ID Template",
  "Logo": "லோகோ",
  "Active": "செயலில்",
  "Approved/In-Active": "Approved/In-Active",
  "Write reason of": "Write reason of",
  "Are you sure that you want to In-Active this record?": "Are you sure that you want to In-Active this record?",
  "Profile Image": "சுயவிவரப் படம்",

  "Notice Pay": "நோட்டீஸ் ஊதியம்",
  "Local Name": "உள்ளூர் பெயர்",
  "expire": "expire",
  "Settlement": "தீர்வு",
  "NOTE: In Time and Out Time in 24 Hrs Format": "NOTE: In Time and Out Time in 24 Hrs Format",
  "Tuesday": "செவ்வாய்க்கிழமை",

  "Pay Code": "Pay Code",
  "Scheduler": "அட்டவணையாளர்",
  "Calender View": "Calender View",
  "Download Sample File": "Download Sample File",
  "Download Sample CSV File": "Download Sample CSV File",
  "Preview Of Shift Scheduler Table": "Preview Of Shift Scheduler Table",
  "Shift Scheduler of Parent Table": "Shift Scheduler of Parent Table",

  "Preview": "முன்னோட்டம்",
  // "Half":"一半",
  "Full Month": "முழு மாதம்",
  "System": "சிஸ்டம்",
  "Approval": "அங்கீகாரம்",
  "Payslip": "சம்பளச் சீட்டு",
  "Designation": "பதவி",
  "Multiplier": "பெருக்கி",
  "Project": "திட்டம்",
  "Members": "உறுப்பினர்கள்",
  "Analytics": "பகுப்பாய்வு",
  "Payment": "பணம் செலுத்துதல்",
  "Approve": "அங்கீகரி",

  "Hours": "மணிநேரங்கள்",
  "Maternal": "Maternal",
  "Adjustment": "சரிசெய்தல்",
  "OT": "OT",
  "Paycodes": "ஊதியக் குறியீடுகள்",
  //"Days": "天",
  "Left": "Left",

  "Joining": "சேர்தல்",
  "Hiring": "நியமனம்",
  "Application": "விண்ணப்பம்",
  "Emergancy": "Emergancy",
  "Contact": "தொடர்பு",
  "Print": "அச்சிடு",
  "Not Consider In Payroll": "Not Consider In Payroll",
  "Sequence No": "Sequence No",
  "Special": "சிறப்பு",
  "Report": "அறிக்கை",
  "Summary": "சுருக்கம்",
  "Out": "வெளியே",
  "Link": "இணைப்பு",
  "Url": "URL",
   "CV": "CV",
  "LinkedIn": "LinkedIn",
  "Final": "இறுதி",
  "Open Payslips": "Open Payslips",
  "Close Payslips": "Close Payslips",
  "Reports": "அறிக்கைகள்",
  "Payroll Reports": "ஊதிய அறிக்கைகள்",
  "Notice Pay Reports": "Notice Pay Reports",
  "Staff IN OUT Reports": "Staff IN OUT Reports",
  "Leave Reports": "விடுப்பு அறிக்கைகள்",
  "Paid": "செலுத்தப்பட்டது",
  "Bank": "வங்கி",
"Evaluated": "மதிப்பீடு செய்யப்பட்டது",
 'Obtained': "பெறப்பட்டது",
 "OneTime": "OneTime",
 "Daily": "தினசரி",
 "HH:MM": "HH:MM",
 "Base Amount": "அடிப்படை தொகை",
 "Month": "மாதம்",
 "Date Range": "தேதி வரம்பு",
 "Staffing": "பணியாளர் ஏற்பாடு",
 "Requirement": "தேவை",
 "Anyalsis": "Anyalsis",
 "Privious": "Privious",
 "Budget": "பட்ஜெட்",
 "To Hire": "To Hire",
 //"Work Plan":"工作计划",
 "Work Plan/KPI": "Work Plan/KPI",
"KPI": "KPI",
"Employee Evalution": "பணியாளர் மதிப்பீடு",
"KPI Project": "KPI திட்டம்",
"Detail": "விவரம்",
"Complete": "முழுமை",
//"value":"",
"Performance": "செயல்திறன்",
"Achieved": "அடைந்தது",
"Improvement": "முன்னேற்றம்",
"Core": "முக்கிய",
"Job Disclosure": "Job Disclosure",
"Post": "இடுகை",
"Employee List": "பணியாளர் பட்டியல்",
"Notice Pay Check": "Notice Pay Check",
"My Work Schedule": "My Work Schedule",
"Employee ID": "பணியாளர் ID",
"QR Code": "QR குறியீடு",
"IDCard": "ID அட்டை",
"Record Added Successfully": "பதிவு வெற்றிகரமாக சேர்க்கப்பட்டது",
"Record Updated Successfully": "பதிவு வெற்றிகரமாக புதுப்பிக்கப்பட்டது",
"Can not Add the Record": "பதிவைச் சேர்க்க முடியாது",
"Account Code -Debit": "Account Code -Debit",
"Account Code - Credit": "Account Code - Credit",
"Pension": "ஓய்வூதியம்",
"Locked": "பூட்டப்பட்டது",
"Show": "காட்டு",
"Saas Code": "Saas Code",
"Font Color": "Font Color",
"Font Style": "Font Style",
"Hexa Code Color Background": "Hexa Code Color Background",
"normal": "normal",
"italic": "italic",
"oblique": "oblique",
"Reserved": "Reserved",
"Error": "பிழை",
"mom": "அம்மா",
"dad": "அப்பா",

  // //"Documents":"Documents",កូដ Saas
  // "Expired":"Expired",
  // "in":"in",
  // "days":"days",
  // "New":"New",
  // "Complaints":"Complaints",
  // "No":"இல்லை",
  // "Messages":"Messages",
  // "Arrived":"Arrived",
  // "Leaves":"Leaves",
  // "today":"today",
  // "My Profile":"My Profile",
  // "Sign out":"Sign out",
  // "Flat Salary":"Flat Salary",
  // "Salary Attendance":"Salary Attendance",
  // "OT":"OT",
  // "Hourly Wages":"Hourly Wages",
  // "NOTE:In Time and Out Time in 24 Hrs Format":"NOTE:In Time and Out Time in 24 Hrs Format",
  // "Please select a date":"Please select a date",
  // "Rest":"Rest",
  // "Early Leaving":"Early Leaving",
  // "Over Time":"Over Time",
  // "Time Late":"Time Late",
  // "Previous":"Previous",
  // "Records":"Records",
  // "Check IN Out Records":"Check IN Out Records",
  // "Check IN":"Check IN",
  // "Select Status":"Select Status",
  // "ADD":"ADD",
  // "Export":"Export",
  // "Active":"Active",
  // "Title":"Title",
  // "Address":"Address",
  // "Owner":"Owner",
  // "Status":"Status",
  // "Action":"Action",
  // "Photo":"Photo",
  // "Select":"Select",
  // "User":"User",
  // "Employee Local Name":"Employee Local Name",
  // "Vehicle":"Vehicle",
  // "Notice Pay":"Notice Pay",
  // "See":"See",
  // "Not found":"Not found",
  // "Upcoming":"Upcoming",
  // "Absent":"Absent",
  // "Expire With in Days":"Expire With in Days",
  // "Leave Bank":"Leave Bank",
  // "To":"To",
  // "Outstanding":"Outstanding",
  // "Mood":"Mood",
  // "No options":"No options",
  // "General":"General",
  // "Very Sad":"Very Sad",
  // "Sad":"Sad",
  // "Just OK":"Just OK",
  // "Good":"Good",
  // "Fantastic":"Fantastic",
  // "Document Type List":"Document Type List",
  // "Dashboard":"Dashboard",
  // "Doc Type":"Doc Type",
  // "All":"All",
  // "Expiry By":"Expiry By",
  // "Days to expire";"Days to expire",
  // "All Expiry Type":"All Expiry Type",
  // "Days to expire":"Days to expire",
  // "Already Expired":"Already Expired",
  // "All Document Type":"All Document Type",
  // "In-Active":"In-Active",
  // "Select Department":"Select Department",
  // "Select Employee":"Select Employee",
  // "Work Schedular":"Work Schedular",
  // "Work Schedular History":"Work Schedular History",
  // "Work Schedular Import":"Work Schedular Import",
  // "Calender View":"Calender View",
  // "Choose File":"Choose File",
  // "No file chosen":"No file chosen",
  // "Download Sample File":"Download Sample File",
  // "Download Sample CSV File":"Download Sample CSV File",
  // "Upload":"Upload",
  // "Preview Of Shift Scheduler Table":"Preview Of Shift Scheduler Table",
  // "Shift Schduler of Parent Table":"Shift Schduler of Parent Table",
  // "All Organization":"All Organization",
  // "Test Payroll":"Test Payroll",
  // "Rate":"Rate",
  // "View":"View",
  // "Payslip":"Payslip",
  // "All Payroll Entry":"All Payroll Entry",
  // "Payroll Title":"Payroll Title",
  // "Employee ID":"Employee ID",
  // "Employee Name":"Employee Name",
  // "Department":"Department",
  // "Designation":"Designation",
  // "Color Code":"Color Code",
  // "Multiplier":"Multiplier",
  // "Pay Code":"Pay Code",
  // "Taxcode":"Taxcode",
  // "Project":"Project",
  // "In Progress":"In Progress",
  // "Closed":"Closed",
  // "Project ID":"Project ID",
  // "Status":"Status",
  // "Open":"Open",
  // "Id":"Id",
  // "Job Title":"Job Title",
  // "Job ID":"Job ID",
  // "Description":"Description",
  // "Close Date":"Close Date",
  // "No Of Candidates Applied":"No Of Candidates Applied",
  // "Number Of":"Number Of",
  // "Url":"Url",
  // "Normal":"Normal",
  // "Document Uploaded":"Document Uploaded",
  // "Public Jobs":"Public Jobs",
  // "Private Jobs":"Private Jobs",
  // "Course List":"Course List",
  // "Course":"Course",
  // "Select Course Type":"Select Course Type",
  // "Departments":"Departments",
  // "Description":"Description",
  // "Cancel":"Cancel",
  // "Chat":"Chat",
  // "Select Department":"Select Department",
  // "Select Organization":"Select Organization",
  // "Load All":"Load All",
  // "SKU":"SKU",
  // "Cost":"Cost",
  // "Price":"Price",
  // "Discount Price":"Discount Price",
  // "Link":"Link",
  // "Brand":"Brand",
  // "Top List":"Top List",
  // "Image Size":"Image Size",
  // "Documents Uploaded":"Documents Uploaded",
  // "Select Status":"Select Status",
  // "No":"இல்லை",
  // "View resume":"View resume",
  // "Applied For":"Applied For",
  // "Applicant":"Applicant",
  // "Application Name":"Application Name",
  // "Applicant Mobile":"Applicant Mobile",
  // "Applicant Email":"Applicant Email",
  // "Status":"Status",
  // "Remark":"Remark",
  // "Thumbnail":"Thumbnail",
  // "Business Promotion":"Business Promotion",
  // "Visitor":"Visitor",
  // "Total IN Visitor":"Total IN Visitor",
  // "QR Code":"QR Code",
  // "Phone":"Phone",
  // "Send QR Code":"Send QR Code",
  // "Not Checked Out":"Not Checked Out",
  // "History":"History",
  // "Open":"Open",
  // "Reported":"Reported",
  // "Created On":"Created On",
  // "Incident From":"Incident From",
  // "Incident Title":"Incident Title",
  // "Incident Form":"Incident Form",
  // "Level":"Level",
  // "Remark":"Remark",
  // "Status":"Status",
  // "Description of incident":"Description of incident",
  // "Check In":"Check In",
  // "code":"code",
  // "Address Line 1":"Address Line 1",
  // "City":"City",
  // "State/Province":"State/Province",
  // "Country":"Country",
  // "Attendance Radius (In Meters)":"Attendance Radius (In Meters)",
  // "Company Policy":"Company Policy",
  // "Employee Handbook":"Employee Handbook",
  // "Payslip Header":"Payslip Header",
  // "Payslip Footer":"Payslip Footer",
  // "Height":"Height",
  // "Width":"Width",
  // "ID Template":"ID Template",
  // "Select Organization Logo":"Select Organization Logo",
  // "Public Holiday":"Public Holiday",
  // "Holiday":"Holiday",
  // "Apply Shift Schduler":"Apply Shift Schduler",
  // "Pay":"Pay",
  // "Name":"Name",
  // "Shifts":"Shifts",
  // "Pay":"Pay",
  // "Negative Balance":"Negative Balance",
  // "This field is invalid":"This field is invalid",
  // "Leave Type":"Leave Type",
  // "Admin app":"Admin app",
  // "URL":"URL",
  // "Asset":"Asset",
  // "Allowance Code":"Allowance Code",
  // "Description":"Description",
  // "Cancel":"Cancel",
  // "Add":"Add",
  // "Document Type":"Document Type",
  // "Employee Group":"Employee Group",
  // "Job ID":"Job ID",
  // "Annoucement":"Annoucement",
  // "Course Type":"Course Type",
  // "System Logs":"System Logs",
  // "User":"User",
  // "User IP":"User IP",
  // "Location":"Location",
  // "Operation":"Operation",
  // "Affected Table":"Affected Table",
  // "Rows":"Rows",
  // "Timestamp":"Timestamp",




  ////Date 20/6/23
  "Point": "Point",
 "Add Payslip Header,Footer,organization logo,ID Template": "Add Payslip Header,Footer,organization logo,ID Template",








///Date 12-06-24////////////////////
"Add on Note": "Add on Note",
"Workplan Evaluation": "Workplan Evaluation",
"Hr Letters": "Hr Letters",
"Letter ": "Letter ",
"HR Admin Payroll Processes": "HR Admin Payroll Processes",
"Payroll Line Entry Record": "Payroll Line Entry Record",
"Closed Payroll Line Entry": "Closed Payroll Line Entry",
"Cancelled Payroll Line Entry": "Cancelled Payroll Line Entry",
"Employee Monthly Target": "Employee Monthly Target",
"Employee Log Activity": "Employee Log Activity",
"Employee Summary Target Activity": "Employee Summary Target Activity",
"Dependant Import": "Dependant Import",
"Leave Import": "Leave Import",
"Assets Import": "Assets Import",
"Salary Import": "Salary Import",
"KPI of completed Project": "KPI of completed Project",
"KPI Attendance Employee": "KPI Attendance Employee",
"KPI Attendance Organization": "KPI Attendance Organization",
"KPI Attendance Organization Listing": "KPI Attendance Organization Listing",
"Groups CheckIN": "Groups CheckIN",
"Groups Attendance Logs": "Groups Attendance Logs",
"Project Groups": "Project Groups",
"Use this  Access Code For Office Entry": "Use this  Access Code For Office Entry",
"Workplan": "Workplan",
"Goal": "இலக்கு",
"Recommendations": "பரிந்துரைகள்",
"Feedback": "கருத்து",
"HR Actions": "HR செயல்கள்",
"Links": "Links",
"Target": "இலக்கு",
"Activity": "செயல்பாடு",
"Evolution": "Evolution",
"Overtime": "ஓவர்டைம்",
"Employee Overtime Request": "Employee Overtime Request",
"Attendance Import": "வருகைப்பதிவு இறக்குமதி",
"Exchange Rate": "மாற்று விகிதம்",
 "Cost": "செலவு",
 "Closed": "மூடப்பட்டது",
 "this": "this",
"OFF": "OFF",
"No Shows": "வரவில்லை",
"No Shows": "வரவில்லை",
"Total Performance": "மொத்த செயல்திறன்",
"Applicant": "விண்ணப்பதாரர்",
"Resume": "வாழ்க்கை வரலாறு",
"Close Date": "மூடும் தேதி",
"Job Id": "வேலை ID",
"No Of Candidates Applied": "No Of Candidates Applied",
"Number Of": "Number Of",
"Minimum": "Minimum",
"Experience": "Experience",
"Load": "Load",
"Send": "Send",
"Price": "Price",
"Discounted": "Discounted",
"SKU": "SKU",
"Brand": "Brand",
"Top List": "Top List",
"Order": "Order",
"For e.g.": "For e.g.",
"HR Letters": "HR Letters",
"HR Letter Fields": "HR Letter Fields",





"IN": "IN",
"OUT": "OUT",
"Appointment": "Appointment",
"Valid": "Valid",
"CheckIN": "CheckIN",
"Reported": "Reported",
"Created On": "Created On",
"Media": "Media",
"Photo": "Photo",
"Holiday": "Holiday",
"Head": "Head",
"Privilege": "Privilege",
"Module": "Module",
"Delete": "Delete",
"Activity Type": "Activity Type",
"Activity Status": "Activity Status",
"Activity Valuation %": "Activity Valuation %",
"Attendance Remarks": "Attendance Remarks",
"Maximum": "Maximum",
"Valuation": "Valuation",
"Exchange": "பரிமாற்றம்",
"User": "User",
"IP": "IP",
"Operation": "Operation",
"Affected": "Affected",
"Table": "Table",
"Rows": "Rows",
"Timestamp": "Timestamp",
"Payroll Process": "Payroll Process",
"Remarks": "Remarks",
"To Date": "முடிவு தேதி",
"Only Salary": "Only Salary",
"Next": "அடுத்து",
"Be Processed": "Be Processed",
  "Early Leaving": "Early Leaving",
  // "Over Time":"Over Time",
  "Time Late": "Time Late",
  "Done": "முடிந்தது",
  "Gross": "மொத்தம்",
  "Pay": "ஊதியம்",
  "Unpaid": "செலுத்தப்படாதது",
  "Dependant": "சார்ந்தவர்",
  "Seniority": "மூத்தத்துவம்",
  "Advanced": "முன்பணம்",
  "Net": "நிகர",
  "Children": "குழந்தைகள்",
  "Ticket": "டிக்கெட்",



"Msg Send Successfully": "Msg Send Successfully",
"Msg Not Send Successfully": "Msg Not Send Successfully",



















  //Manage Tax Brackets             ,  
};
// }
// else
// {



// module.exports = {
//   "Employees List":
//     "Employees List",
//     "Dashboard":
//     "Dashboard",
//     "Select Organization":
//     "Select Organization",
//     "Status":
//     "Status",
//     "Select Department":
//     "Select Department",
//     "Select Positions":
//     "Select Positions",
//     "Export":
//     "Export",
//     "Import +":
//     "Import +",
//     "Update Qrcode":
//     "Update Qrcode",
//     "Search":
//     "Search",
// };

// }


